
import './index.less'
import Nav from './components/Nav/index.jsx'
import CompMain from './components/compMain/index.jsx'
import Tips1 from './components/tips1/index.jsx'
import Tips2 from './components/tips2/index.jsx'
import Popup from './components/popup/index1.jsx'
import { useState } from 'react'
import clone from './utils/clone.js'
import React from 'react'
import BasicsSide from './components/basicsSide/index.jsx'
import { createLandingPage, modifyLandingPage } from '@/api/landingPage.js'
import { Radio, Button } from 'antd'

console.log(React)
export default function NewNativePromotionPage(props) {
  const [ifon, setIfon] = useState({
    components: clone(props.components, true),
    pressItem: null,
    pressItem1: null,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null,
    activeComps: handleActiveComps(props.components[0].comps),
    selectItem: null,
    isPopup: false,
    rotationIndex: 0,
    pageType: 'createPage',
    value: 1,
    is: false
  })
  const [sharingSettings, setSharingSettings] = useState({
    name: props.information.name,
    title: props.information.title,
    gzh: '',
    back: props.information.back
  })

  window.aaa = ifon
  window.wll = sharingSettings

  return (
    <div className='newNativePromotionPage'>
      {ifon.pageType === 'createPage' && <div className='newNativePromotionPage_headArea'>
        <div className='headArea_no1'>
          <div className='no1_left'>
            <h2 className='title' style={{ color: '#ffffff' }}>新建阅宝落地页</h2>
          </div>
          <div className='no2_right'>
            <ul className='right_option'>
              <li className='item' onClick={() => {
                setIfon({
                  ...ifon,
                  isPopup: 'isItVisible'
                })
              }}>
                <span className='item_text'>{props.account_id === 'onlyView' ? '只能查看' : props.account_id && props.account_id !== 'onlyView' ? '修改' : '创建'}</span>
              </li>
              {/* <li className='item'>
                <span className='item_text'>送审</span>
              </li> */}
            </ul>
          </div>
        </div>

      </div>}

      <div className='newNativePromotionPage_main'>

        {ifon.pageType === 'createPage' ? <React.Fragment>
          <div className='main_nav'>
            <Nav
              pressAndHold={(obj) => {
                handleNavPress(obj, ifon, setIfon)
              }}
              move={(obj) => {
                handleNavMove(obj, ifon, setIfon)
              }}
              up={(obj) => {
                handleNavUp(obj, ifon, setIfon)
              }}
              activeComps={ifon.activeComps}
              beBasedOn={props['be-based-on']}
            ></Nav>
          </div>

          <div className='main_main' onClick={(e) => {
            if (e.target.className === 'box_item' || e.target.className === 'main_main') {
              setIfon({
                ...ifon,
                selectItem: null
              })
            }
          }}>
            <CompMain
              components={ifon.components}
              pressItem={ifon.pressItem}
              comps={ifon.comps}
              pressAndHold={(obj) => {
                handleItemPress(obj, ifon, setIfon)
              }}
              move={(obj) => {
                handleItemMove(obj, ifon, setIfon)
              }}
              up={(obj) => {
                handleItemUp(obj, ifon, setIfon)
              }}
              addFlipping={() => {
                addFlipping(ifon, setIfon)
              }}
              deleteFlipping={(index) => {
                deleteFlipping(index, ifon, setIfon)
              }}
              deleteItem={(id) => {
                deleteItem(id, ifon, setIfon)
              }}
              selectItem={ifon.selectItem}
              hoistPopup={() => {
                ifon.isPopup = 'Popup'
                setIfon({
                  ...ifon
                })
              }}
              setBack={(components) => {
                setIfon({
                  ...ifon,
                  components
                })
              }}
              mySetIfon={(myIfon) => {
                mySetIfon(myIfon, ifon, setIfon)
              }}
              backColor={sharingSettings.back}
            ></CompMain>

          </div>

          <div className='main_side'>
            {(ifon.selectItem && ifon.selectItem.sideComp) ? <ifon.selectItem.sideComp
              key={ifon.selectItem.id}
              ifon={ifon.selectItem.ifon}
              mySetIfon={(myIfon) => {
                mySetIfon(myIfon, ifon, setIfon)
              }}
              hoistPopup={(index = null) => {
                setIfon({
                  ...ifon,
                  isPopup: true,
                  rotationIndex: index === null ? ifon.rotationIndex : index
                })
              }}
              components={ifon.components}
            /> : <BasicsSide sharingSettings={sharingSettings} setSharingSettings={(ifon) => {
              setSharingSettings({
                ...ifon
              })
            }}></BasicsSide>}
          </div></React.Fragment> : null}
      </div>

      {ifon.isPopup && <div className='Mantle' is={ifon.is}>
        { ifon.isPopup === 'isItVisible' && <div className='isItVisible'>
          <div className='isItVisible_main'>
            <Radio.Group onChange={(e) => {
              setIfon({
                ...ifon,
                value: e.target.value,
                is: !ifon.is
              })
            }} value={ifon.value}>
              <Radio value={1}>可见</Radio>
              <Radio value={2}>不可见</Radio>
            </Radio.Group>
          </div>
          <div className='isItVisible_button'>
            <Button style={{ margin: '0px 10px' }} onClick={() => {
              setIfon({
                ...ifon,
                isPopup: !ifon.isPopup
              })
            }}>取消</Button>
            <Button type='primary' style={{ margin: '0px 10px' }} onClick={() => {
              if (props.account_id && props.account_id !== 'onlyView') {
                modify(ifon, sharingSettings, props.account_id, props)
                setIfon({
                  ...ifon,
                  isPopup: 'waiting'
                })
              } else if (!props.account_id) {
                create(ifon, sharingSettings, props)
                setIfon({
                  ...ifon,
                  isPopup: 'waiting'
                })
              }
            }}>确定</Button>
          </div>
        </div>}

        { ifon.isPopup === 'Popup' && <Popup close={() => {
          setIfon({
            ...ifon,
            isPopup: false
          })
        }} rule={(page, callback) => {
          rule(page, callback, ifon, setIfon)
        }} determine={(item) => {
          determine(item, ifon, setIfon, sharingSettings, setSharingSettings)
        }}></Popup>}

        { ifon.isPopup === 'waiting' && <div className='waiting'>
          <img src='http://www.sucaijishi.com/uploadfile/2014/0524/20140524124233131.gif' />
          <span>创建中···</span>
        </div>}

      </div>}

    </div >
  )
}

NewNativePromotionPage.defaultProps = {
  components: [{
    back: '#ffffff',
    id: Math.random(),
    comps: []
  }],
  information: {
    title: '',
    name: '',
    gzh: '',
    back: '#ffffff'
  },
  name: ''
}

function handleNavPress(obj, ifon, setIfon) {
  if (!obj.ifon.name.startsWith('top')) {
    addComp(ifon, 0, ifon.components[0].comps.length, 0, {
      id: Math.random(),
      comp: Tips2,
      name: 'tips2'
    })
  }
  setIfon({
    ...ifon,
    pressItem: obj.ifon,
    pressX: obj.pressX,
    pressY: obj.pressY
  })
}

function handleNavMove(obj, ifon, setIfon) {
  if (ifon.pressItem.name.startsWith('top_')) {
    return
  }

  for (let i = 0; i < ifon.components.length; i++) {
    const compBoxIfon = ifon.components[i].compBox.getBoundingClientRect()
    const contentIfon = ifon.components[i].content.getBoundingClientRect()
    const bool1 = (obj.moveX >= compBoxIfon.x) && (obj.moveX <= (compBoxIfon.x + compBoxIfon.width))
    const bool2 = (obj.moveY >= compBoxIfon.y) && (obj.moveY <= (compBoxIfon.y + compBoxIfon.height))
    const bool3 = (obj.moveX >= contentIfon.x) && (obj.moveX <= (contentIfon.x + contentIfon.width))
    const bool4 = (obj.moveY >= contentIfon.y) && (obj.moveY <= (contentIfon.y + contentIfon.height))

    let tips2Index
    const s = ifon.components[i].comps.filter((item, index) => {
      if (item.comp === Tips2) {
        tips2Index = index
      }
      return item.comp === Tips2
    })
    let lindex, tindex

    if (bool1 && bool2) {
      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))
          const half = calCompIfon.height / 2 + calCompIfon.y

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp !== Tips2)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]

              if (i === 0 && l === 0) {
                if (half < obj.moveY) {
                  lindex = tips2Index + 1
                  tindex = 1
                  displacement(ifon.components[i].comps, lindex, tindex, comp)
                  break
                }
              } else {
                if (tips2Index > l) {
                  lindex = tips2Index + 1
                  if (half < obj.moveY) {
                    tindex = l + 1
                  } else {
                    tindex = l
                  }
                } else {
                  lindex = tips2Index
                  if (half < obj.moveY) {
                    tindex = l + 1
                  } else {
                    tindex = l
                  }
                }
              }

              displacement(ifon.components[i].comps, lindex, tindex, comp)
              break
            } else {
              deleteTips2(ifon)

              if (half < obj.moveY) {
                addComp(ifon, i, l + 1, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              } else {
                addComp(ifon, i, l, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              }
            }
          }
        }
      } else {
        if (s.length) {
          const item = ifon.components[i].comps[tips2Index]
          displacement(ifon.components[i].comps, tips2Index, ifon.components[i].comps.length, item)
          break
        } else {
          deleteTips2(ifon)
          addComp(ifon, i, ifon.components[i].comps.length, 0, {
            id: Math.random(),
            name: 'tips2',
            comp: Tips2
          })
          break
        }
      }
    }
  }

  setIfon({
    ...ifon,
    moveX: obj.moveX,
    moveY: obj.moveY
  })
}

function handleNavUp(obj, ifon, setIfon) {
  if (obj.upX === ifon.pressX && obj.upY === ifon.pressY) {
    const item = {
      id: Math.random(),
      comp: ifon.pressItem.contentComp,
      name: ifon.pressItem.name,
      copyComp: ifon.pressItem.contentCopyComp,
      sideComp: ifon.pressItem.sideComp,
      ifon: clone(ifon.pressItem.ifon, true)
    }
    if (obj.ifon.name.startsWith('top')) {
      addComp(ifon, 0, 0, 1, item)
      ifon.selectItem = item
    } else if (ifon.pressItem.name === 'marketing_suspension_comp') {
      if (ifon.components.length === 1) {
        item.original = 0
        const obj = item
        addComp(ifon, 0, ifon.components[0].comps.length, 0, obj)
        ifon.selectItem = item
      } else {
        item.original = ifon.components.length - 1
        const obj = item
        addComp(ifon, ifon.components.length - 1, ifon.components[0].comps.length, 0, obj)
        ifon.selectItem = obj
      }
    } else {
      addComp(ifon, 0, ifon.components[0].comps.length, 0, item)
      ifon.selectItem = item
    }

    ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
  } else {
    for (let i = 0; i < ifon.components.length; i++) {
      for (let l = 0; l < ifon.components[i].comps.length; l++) {
        const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
        const bool5 = (obj.upX >= calCompIfon.x) && (obj.upX <= (calCompIfon.x + calCompIfon.width))
        const bool6 = (obj.upY >= calCompIfon.y) && (obj.upY <= (calCompIfon.y + calCompIfon.height))

        if (bool5 && bool6 && ((ifon.components[i].comps[l].comp === Tips1) || (ifon.components[i].comps[l].comp === Tips2))) {
          const item = {
            id: Math.random(),
            name: ifon.pressItem.name,
            comp: ifon.pressItem.contentComp,
            copyComp: ifon.pressItem.contentCopyComp,
            sideComp: ifon.pressItem.sideComp,
            ifon: clone(ifon.pressItem.ifon, true)
          }
          if (ifon.pressItem.name.startsWith('top_')) {
            if ((ifon.components[i].comps[l].comp === Tips1) && (i === 0) && (l === 0)) {
              displacement(ifon.components[i].comps, 1, 0, item)
              ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
              ifon.selectItem = item
              break
            }
          } else if (ifon.components[i].comps[l].comp === Tips2) {
            if (ifon.pressItem.name === 'marketing_suspension_comp') {
              if (i === (ifon.components.length - 1)) {
                const obj = { ...item, original: ifon.components.length - 1 }
                addComp(ifon, i, l, 0, obj)
                ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
                ifon.selectItem = obj
                break
              } else {
                alert('该组件只支持放在最后一页')
                break
              }
            } else {
              addComp(ifon, i, l, 0, item)
              ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
              ifon.selectItem = item
              break
            }
          }
        }
      }
    }
  }

  deleteTips2(ifon)

  setIfon({
    ...ifon,
    pressItem: null,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null
  })
}

function handleItemPress(obj, ifon, setIfon) {
  setIfon({
    ...ifon,
    pressItem1: obj.ifon,
    pressX: obj.pressX,
    pressY: obj.pressY
  })
}

function handleItemMove(obj, ifon, setIfon) {
  for (let i = 0; i < ifon.components.length; i++) {
    const compBoxIfon = ifon.components[i].compBox.getBoundingClientRect()
    const contentIfon = ifon.components[i].content.getBoundingClientRect()
    const bool1 = (obj.moveX >= compBoxIfon.x) && (obj.moveX <= (compBoxIfon.x + compBoxIfon.width))
    const bool2 = (obj.moveY >= compBoxIfon.y) && (obj.moveY <= (compBoxIfon.y + compBoxIfon.height))
    const bool3 = (obj.moveX >= contentIfon.x) && (obj.moveX <= (contentIfon.x + contentIfon.width))
    const bool4 = (obj.moveY >= contentIfon.y) && (obj.moveY <= (contentIfon.y + contentIfon.height))
    let tips2Index
    const s = ifon.components[i].comps.filter((item, index) => {
      if (item.comp === Tips2) {
        tips2Index = index
      }
      return item.comp === Tips2
    })

    if (bool1 && bool2) {
      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))
          const half = calCompIfon.height / 2 + calCompIfon.y
          const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
          const targetIfon = getIndexes(ifon.components, ifon.components[i].comps[l].id)

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp !== Tips2) && (ifon.pressItem1.id !== ifon.components[i].comps[l].id)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]
              let lindex, tindex

              if (pressIfon.father === targetIfon.father) {
                /* if (i === 0 && l === 0 && false) {
                } else { */
                if (tips2Index < l) {
                  lindex = tips2Index

                  if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                    if (pressIfon.son + 1 === targetIfon.son) {
                      if (half < obj.moveY) {
                        tindex = l + 1
                        displacement(ifon.components[i].comps, lindex, tindex, comp)
                        break
                      }
                    } else {
                      if (half > obj.moveY) {
                        tindex = l
                        displacement(ifon.components[i].comps, lindex, tindex, comp)
                        break
                      }
                    }
                  } else {
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }

                    displacement(ifon.components[i].comps, lindex, tindex, comp)
                    break
                  }
                } else {
                  lindex = tips2Index + 1

                  if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                    if (pressIfon.son + 1 === targetIfon.son) {
                      if (half > obj.moveY) {
                        tindex = l + 1
                        displacement(ifon.components[i].comps, lindex, tindex, comp)
                        break
                      }
                    } else {
                      if (half < obj.moveY) {
                        tindex = l
                        displacement(ifon.components[i].comps, lindex, tindex, comp)
                        break
                      }
                    }
                  } else {
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }
                    displacement(ifon.components[i].comps, lindex, tindex, comp)
                    break
                  }
                }
                /* } */
              } else {
                if (i === 0 && l === 0) {
                  if (half < obj.moveY) {
                    if (((i === 0) && (pressIfon.son > 1)) || i !== 0) {
                      lindex = tips2Index + 1
                      tindex = 1
                      displacement(ifon.components[i].comps, lindex, tindex, comp)
                      break
                    }
                  }
                } else {
                  if (tips2Index < l) {
                    lindex = tips2Index
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }
                  } else {
                    lindex = tips2Index + 1
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }
                  }

                  displacement(ifon.components[i].comps, lindex, tindex, comp)
                  break
                }
              }
            } else {
              if (pressIfon.father === targetIfon.father) {
                let indexl
                const item = {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                }

                /* if (i === 0 && l === 0 && false) {
                } else { */
                deleteTips2(ifon)

                if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                  if (pressIfon.son + 1 === targetIfon.son) {
                    if (obj.moveY > half) {
                      indexl = l + 1
                      addComp(ifon, i, indexl, 0, item)
                      break
                    }
                  } else {
                    if (obj.moveY < half) {
                      indexl = l
                      addComp(ifon, i, indexl, 0, item)
                      break
                    }
                  }
                } else {
                  if (half > obj.moveY) {
                    indexl = l
                  } else {
                    indexl = l + 1
                  }
                  addComp(ifon, i, indexl, 0, item)
                  break
                }
                /* } */
              } else {
                deleteTips2(ifon)
                let indexl

                if (i === 0 && l === 0) {
                  if (obj.moveY > half) {
                    indexl = 1
                    addComp(ifon, i, indexl, 0, {
                      id: Math.random(),
                      name: 'tips2',
                      comp: Tips2
                    })
                    break
                  }
                } else {
                  if (half < obj.moveY) {
                    indexl = l + 1
                  } else {
                    indexl = l
                  }

                  addComp(ifon, i, indexl, 0, {
                    id: Math.random(),
                    name: 'tips2',
                    comp: Tips2
                  })
                  break
                }
              }
            }
          }
        }
      } else {
        const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
        let half
        let targetIfon
        console.log(half)
        for (let i = 0; i < ifon.components.length; i++) {
          for (let l = 0; l < ifon.components[i].comps.length; l++) {
            const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
            const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
            const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))

            if (bool5 && bool6) {
              half = calCompIfon.height / 2 + calCompIfon.y
              targetIfon = getIndexes(ifon.components, ifon.components[i].comps[l].id)
              break
            }
          }
          if (targetIfon) {
            break
          }
        }

        if (targetIfon) {
          if (pressIfon.father === targetIfon.father) {
            break
          } else {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]
              let lindex, tindex

              if (targetIfon.son === ifon.components[i].comps.length - 1) {
                lindex = tips2Index
                tindex = ifon.components[i].comps.length - 1
              } else {
                lindex = tips2Index
                tindex = ifon.components[i].comps.length
              }

              displacement(ifon.components[i].comps, lindex, tindex, comp)
              break
            } else {
              deleteTips2(ifon)

              if (targetIfon.son === ifon.components[i].comps.length - 1) {
                addComp(ifon, targetIfon.father, ifon.components[i].comps.length - 1, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              } else {
                addComp(ifon, targetIfon.father, ifon.components[i].comps.length, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              }
            }
          }
        } else {
          let bool6 = true

          const s1 = ifon.components[i].comps.filter((item) => {
            return item.name === 'marketing_suspension_comp'
          })

          if (s1.length && (getIndexes(ifon.components, s1[0].id).father === pressIfon.father)) {
            if ((getIndexes(ifon.components, s1[0].id).son === (ifon.components[i].comps.length - 1)) && (pressIfon.son === (ifon.components[i].comps.length - 2))) {
              bool6 = false
            }
          }

          if (((pressIfon.father === i) && (pressIfon.son < (ifon.components[i].comps.length - 1)) && bool6) || (pressIfon.father !== i)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]

              displacement(ifon.components[i].comps, tips2Index, ifon.components[i].comps.length, comp)
              break
            } else {
              deleteTips2(ifon)
              addComp(ifon, i, ifon.components[i].comps.length, 0, {
                id: Math.random(),
                name: 'tips2',
                comp: Tips2
              })
              break
            }
          }
        }
      }
    }
  }

  setIfon({
    ...ifon,
    moveX: obj.moveX,
    moveY: obj.moveY
  })
}

function handleItemUp(obj, ifon, setIfon) {
  if ((ifon.pressX === obj.upX) && (ifon.pressY === obj.upY)) {
    ifon.selectItem = ifon.pressItem1
  } else {
    for (let i = 0; i < ifon.components.length; i++) {
      const contentIfon = ifon.components[i].content.getBoundingClientRect()
      const bool3 = (obj.upX >= contentIfon.x) && (obj.upX <= (contentIfon.x + contentIfon.width))
      const bool4 = (obj.upY >= contentIfon.y) && (obj.upY <= (contentIfon.y + contentIfon.height))

      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.upX >= calCompIfon.x) && (obj.upX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.upY >= calCompIfon.y) && (obj.upY <= (calCompIfon.y + calCompIfon.height))

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp === Tips2)) {
            const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
            const item = ifon.pressItem1

            addComp(ifon, i, l, 1, item)
            ifon.components[pressIfon.father].comps.splice(pressIfon.son, 1)
            break
          }
        }
      }
    }
  }

  deleteTips2(ifon)
  setIfon({
    ...ifon
  })
}

function addComp(ifon, father, son, term, comp) {
  ifon.components[father].comps.splice(son, term, comp)
}

function deleteTips2(ifon) {
  for (let i = 0; i < ifon.components.length; i++) {
    ifon.components[i].comps = ifon.components[i].comps.filter((item) => {
      return item.comp !== Tips2
    })
  }
}

function displacement(arr, lindex, tindex, com) {
  arr.splice(tindex, 0, com)
  arr.splice(lindex, 1)
}

function getIndexes(arr, id) {
  for (let i = 0; i < arr.length; i++) {
    for (let l = 0; l < arr[i].comps.length; l++) {
      if (arr[i].comps[l].id === id) {
        return {
          son: l,
          father: i
        }
      }
    }
  }
}

function deleteItem(id, ifon, setIfon) {
  const itemIfon = getIndexes(ifon.components, id)
  const name = ifon.components[itemIfon.father].comps[itemIfon.son].name

  if (name.startsWith('top_')) {
    displacement(ifon.components[itemIfon.father].comps, itemIfon.son, 1, {
      id: Math.random(),
      name: 'Tips1',
      comp: Tips1
    })
    ifon.activeComps = ifon.activeComps.filter((name1) => {
      return name1 !== name
    })
  } else {
    ifon.components[itemIfon.father].comps.splice(itemIfon.son, 1)
    let bool = false
    for (let i = 0; i < ifon.components.length; i++) {
      for (let l = 0; l < ifon.components[i].comps.length; l++) {
        if (ifon.components[i].comps[l].name === name) {
          bool = true
          break
        }
      }
    }
    if (!bool) {
      ifon.activeComps = ifon.activeComps.filter((name1) => {
        return name1 !== name
      })
    }
  }

  if (ifon.selectItem && (ifon.selectItem.id === id)) {
    ifon.selectItem = null
  }

  setIfon({
    ...ifon
  })
}

function addFlipping(ifon, setIfon) {
  let suspension

  for (let i = 0; i < ifon.components.length; i++) {
    for (let l = 0; l < ifon.components[i].comps.length; l++) {
      if (ifon.components[i].comps[l].name === 'marketing_suspension_comp') {
        suspension = ifon.components[i].comps[l]
        ifon.components[i].comps.splice(l, 1)
        break
      }
    }
    if (suspension) {
      break
    }
  }

  ifon.components.push({
    back: '#ffffff',
    comps: [],
    id: Math.random()
  })

  if (suspension) {
    ifon.components[ifon.components.length - 1].comps.push(suspension)
  }

  setIfon({
    ...ifon
  })
}

function deleteFlipping(index, ifon, setIfon) {
  const s = ifon.components[index].comps.filter((item) => {
    return item.name === 'marketing_suspension_comp'
  })
  ifon.components.splice(index, 1)
  if (s.length && (s[0].original !== index)) {
    ifon.components[ifon.components.length - 1].comps.push(s[0])
  }
  setIfon({
    ...ifon
  })
}

async function rule(page, callback, ifon, setIfon) {
  return
}

function determine(item, ifon, setIfon, sharingSettings, setSharingSettings) {
  if (ifon.pageType === 'createPage') {
    if (ifon.selectItem.name === 'top_image_comp') {
      if (ifon.selectItem.ifon.ad_location === 'sns') {
        if (ifon.selectItem.ifon.outer_style) {
          ifon.selectItem.ifon.imgeIfon.sns.cardAdvertising = item
        } else {
          ifon.selectItem.ifon.imgeIfon.sns.regularAdvertising = item
        }
      } else {
        ifon.selectItem.ifon.imgeIfon.gzh = item
      }
    } else if (ifon.selectItem.name === 'top_carousel_comp') {
      ifon.selectItem.ifon.image_id_list[ifon.rotationIndex] = item
    } else if (ifon.selectItem.name === 'basics_image_comp') {
      ifon.selectItem.ifon.imageIfon = item
    } else if (ifon.selectItem.name === 'marketing_suspension_comp') {
      ifon.selectItem.ifon.imageIfon = item
    }

    setIfon({
      ...ifon,
      isPopup: false
    })
  } else if (ifon.pageType === 'setPage') {
    sharingSettings.thumbnail = item
    setSharingSettings({
      ...sharingSettings
    })
    setIfon({
      ...ifon,
      isPopup: false
    })
  }
}

function handleActiveComps(comps) {
  const acvs = []
  for (let i = 0; i < comps.length; i++) {
    acvs.includes(comps[i].name) || acvs.push(comps[i].name)
  }
  return acvs
}

function mySetIfon(myIfon, ifon, setIfon) {
  if (!ifon.selectItem) {
    return
  }
  ifon.selectItem.ifon = myIfon
  setIfon({
    ...ifon
  })
}

function assemblyData(comps) {
  const models = []

  for (let i = 0; i < comps.length; i++) {
    if (comps[i].name === 'image_comp') {
      models.push(image_comp(comps[i], getText(models, 'YBImages')))
    } else if (comps[i].name === 'text_comp') {
      models.push(text_comp(comps[i], getText(models, 'YBText')))
    } else if (comps[i].name === 'button_comp') {
      models.push(button_comp(comps[i], getText(models, 'YBWXButton')))
    }
  }

  return models
}

function image_comp(item, index) {
  const obj = {
    type: 'YBImages',
    config: {
      images: [],
      imagesGroup: {
        use: false,
        disabled: false,
        uploadImageConfig: 'single',
        data: []
      },
      'iosAppId': '',
      'androidAppId': ''
    },
    id: `YBImages_${parseInt(Math.random() * 100000000000)}`,
    moduleViewId: `图片_${index}`
  }

  const te = ['backTop', 'backBottom', 'gzh', 'link']

  for (let i = 0; i < item.ifon.imageList.length; i++) {
    obj.config.images.push({
      image: {
        height: item.ifon.imageList[i].fileIfon.height,
        width: 375, // item.ifon.imageList[i].fileIfon.width
        url: item.ifon.imageList[i].fileIfon.zSrc,
        guassianUrl: item.ifon.imageList[i].fileIfon.zSrc,
        size: item.ifon.imageList[i].fileIfon.size
      },
      padding: {
        top: item.ifon.imageList[i].fileIfon.paddingTop,
        bottom: item.ifon.imageList[i].fileIfon.paddingBottom,
        left: item.ifon.imageList[i].fileIfon.paddingLeft,
        right: item.ifon.imageList[i].fileIfon.paddingRight
      }
    })

    obj.config.images[i][`hotArea`] = {
      divertList: '',
      isDiverting: item.ifon.imageList[i].isHotZone,
      isSet: item.ifon.imageList[i].isHotZone,
      num: `${item.ifon.imageList[i].hotZoneQuantity.length}`,
      suffixType: 'randomSuffix',
      wxOaInfo: {}
    }

    for (let l = 0; l < /* item.ifon.imageList[i].hotZoneQuantity.length */3; l++) {
      const hotZone = item.ifon.imageList[i].hotZone[l]
      obj.config.images[i][`hotArea${l + 1}`] = {
        link: {
          deepLinkUrl: '',
          formId: 0,
          linkType: te[hotZone.goTo],
          url: te[hotZone.goTo] === 'link' ? hotZone.link : ''
        },
        position: {
          top: hotZone.y / item.ifon.imageList[i].fileIfon.height * 100,
          left: hotZone.x / 375 * 100
        },
        style: {
          width: hotZone.width / 375 * 100,
          height: hotZone.height / item.ifon.imageList[i].fileIfon.height * 100
        }
      }
    }
  }

  return obj
}

function text_comp(item, index) {
  const ifon = item.ifon
  const te = ['border-none', 'border-dott', 'border-solid', 'border-dashed', 'border-dobbule-solid']
  return {
    config: {
      border: {
        color: ifon.frameColor,
        radius: ifon.fillet,
        style: te[ifon.textStyle],
        width: ifon.thickness
      },
      content: {
        differRichEditor: ifon.html,
        text: ifon.html,
        basicRich: '',
        editorType: 'richEditor',
        richEditor: ifon.html
      },
      isSetBorder: ifon.isFrame,
      style: {
        color: ifon.color,
        backgroundColor: ifon.colorBack,
        marginBottom: ifon.paddingBottom,
        marginLeft: ifon.paddingLeft,
        marginRight: ifon.paddingRight,
        marginTop: ifon.paddingTop,
        paddingBottom: ifon.framePaddingBottom,
        paddingLeft: ifon.framePaddingLeft,
        paddingRight: ifon.framePaddingRight,
        paddingTop: ifon.framePaddingTop
      },
      images: [],
      iosAppId: '',
      androidAppId: ''
    },
    id: `YBText_${parseInt(Math.random() * 100000000000)}`,
    type: 'YBText',
    moduleViewId: `文本_${index}`

  }
}

function button_comp(item, index) {
  const ifon = item.ifon
  const te = ['left', 'center', 'right']
  return {
    config: {
      wrapper: {
        marginBottom: ifon.paddingBottom,
        marginLeft: ifon.paddingLeft,
        marginRight: ifon.paddingRight,
        marginTop: ifon.paddingTop,
        textAlign: te[ifon.layout]
      },
      content: {
        linkType: 'link',
        text: ifon.text,
        url: ifon.link
      },
      position: {
        isFixed: ifon.isSuspension,
        toBottom: ifon.bottomDistance,
        whiteSpace: ifon.message
      },
      style: {
        backgroundColor: ifon.backColor,
        borderRadius: ifon.fillet,
        color: ifon.color,
        fontSize: ifon.fontSize,
        lineHeight: ifon.height,
        width: ifon.width
      }
    },
    id: `YBWXButton_${parseInt(Math.random() * 100000000000)}`,
    type: 'YBWXButton',
    moduleViewId: `按钮_${index}`

  }
}

function getText(models, text) {
  const s = models.filter((item) => {
    return item.type === text
  })
  return s.length + 1
}

function pageConfig(sharingSettings) {
  return {
    config: {
      bgColor: sharingSettings.back,
      pageName: sharingSettings.name,
      pageTitle: sharingSettings.title,
      appId: '',
      deepLink: '',
      iosAppId: '',
      androidAppId: '',
      content: {
        wxId: ''
      },
      catalogId: 0,
      novelId: '',
      wxOa: '',
      quickLink: '',
      standbyLink: ''
    },
    type: 'YB_WECHAT_PAGE'
  }
}

async function create(ifon, sharingSettings, props) {
  const data = redundancy(ifon, sharingSettings)
  await createLandingPage(data)
  props.goPublic && props.goPublic()
}

async function modify(ifon, sharingSettings, id, props) {
  const data = redundancy(ifon, sharingSettings)
  await modifyLandingPage(data, id)
  props.goPublic && props.goPublic()
}

function redundancy(ifon, sharingSettings) {
  const obj = {
    content: {
      content: {
        modules: assemblyData(ifon.components[0].comps),
        pageConfig: pageConfig(sharingSettings),
        publishStatus: 'LANDING_PAGE_STATUS_UNPUBLISH'
      },
      wxId: ''
    },
    advertiserId: 21093053,
    androidAppId: '',
    coverUrl: 'http://xj.gdtimg.com/xjimg/0/45b43c50e1fe8e2c24e417d0ea6f02e360384b1d.png/0',
    dynamic: {
      catalogId: 0,
      firstType: '',
      pCount: 0,
      templists: [],
      use: false
    },
    extendedInfo: {
      supportedCardType: '0'
    },
    formIds: [0],
    id: 0,
    iosAppId: '',
    isBatch: false,
    landingPageValidateStatus: 'SUCCESS',
    novelId: 'O_21093053_42412_XD3QMAwoPJaj4RjbbDRke0BmNn6p15LZ',
    pageName: sharingSettings.name,
    pageTitle: sharingSettings.title,
    quickLink: '',
    standbyLink: '',
    templateId: 0,
    type: 'YUEBAO_OFFICIAL_ACCOUNT_ARTICLE',
    wxOa: ''
  }

  return {
    type: 'YUEBAO_OFFICIAL_ACCOUNT_ARTICLE',
    json: JSON.stringify(obj),
    page_name: sharingSettings.name,
    page_title: sharingSettings.title,
    is_public: ifon.value
  }
}

